import { render } from "./AddressAdmin.vue?vue&type=template&id=1e798e0c"
import script from "./AddressAdmin.vue?vue&type=script&lang=js"
export * from "./AddressAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__